import React from "react";
import { useAppState } from "src/app/state/StateProvider";
import AppRow from "src/commun/composants/grille/AppRow";
import AppCol from "src/commun/composants/grille/AppCol";
import styles from "src/app/menu/MenuMonEspacePrive.scss";
import { ChangeLangue } from "src/app/menu/langue/AppChangeLangue";
import MenuSelectionAffilie from "src/commun/composants/MenuSelectionAffilie/MenuSelectionAffilie";
import Wallet from "src/app/menu/wallet/Wallet";
import Applications from "src/app/menu/applications/Applications";
import MonCompte from "src/app/menu/moncompte/MonCompte";
import AppIconHome from "src/commun/composants/AppIconHome/AppIconHome";
import { AppBouton } from "fer-react-components";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "src/routes/AppRoutes";
import { useAppText } from "src/commun/composants/AppText";

const MenuMonEspacePrive = () => {
  const [state] = useAppState();
  const navigate = useNavigate();
  const { tString } = useAppText();
  return (
    <AppRow className={styles.headerContainer}>
      <AppCol xs md="auto">
        <AppIconHome />
      </AppCol>

      <AppCol xs={{ order: 'last' }} sm>
        {!state.user?.comptePersonnel &&
          state.user?.typePersonne === "Externe" ?
          <MenuSelectionAffilie affilies={state.employeurs}/>
          : state.user?.admin ?
            (
              <AppBouton id="BoutonAdministrationServices" typeBouton="PRIMAIRE" onClick={() => {
                navigate(AppRoutes.ADMIN_PATH.route);
              }} className={styles.boutonAdmin}>
                {tString("admin.boutton.titre")}
              </AppBouton>
            ) : <></>
        }
      </AppCol>

      <AppCol xs={"auto"} sm={{ order: 'last' }} className={styles.pointsMenuContainer}>
        {state.user && (
          <AppRow>
            <AppCol>
              <span className={styles.pointMenu}>
                <ChangeLangue/>
              </span>
              <span className={styles.pointMenu}>
                <Applications/>
              </span>
              <span className={styles.pointMenu}>
                <Wallet/>
              </span>
              <span className={styles.pointMenu}>
                <MonCompte/>
              </span>
            </AppCol>
          </AppRow>
        )}
      </AppCol>

    </AppRow>
  );
};

export default MenuMonEspacePrive;
